import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { CheckCircleIcon } from '@calendly/ui/components/icons'
import { Link } from '@calendly/ui/components/link'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import { colorSurfaceSuccess } from '@calendly/ui/theme'

import {
  Message,
  ConfirmationHeader,
  ConfirmationTitle
} from './styles'

const HelpCenterLink = ({ children }) => (
  <Link href="https://calendly.com/help/how-to-block-someone-from-booking-with-you" target="_blank" rel="noopener noreferrer">
    {children}
  </Link>
)

export const BlockConfirmationModal = ({ onClose, onBlockSuccess, isPast }) => {
  const handleClose = () => {
    if (onBlockSuccess) {
      onBlockSuccess()
    }
    onClose()
  }

  const title = isPast
    ? I18n.t('publisher.block_invitee.success_modal.title_attendee')
    : I18n.t('publisher.block_invitee.success_modal.title_invitee')

  return (
    <Popup
      onClose={handleClose}
    >
      <Body>
        <ConfirmationHeader>
          <CheckCircleIcon size="large" color={colorSurfaceSuccess} />
          <ConfirmationTitle>
            {title}
          </ConfirmationTitle>
        </ConfirmationHeader>
        <Message>
          {HtmlParser(I18n.t('publisher.block_invitee.success_modal.message'), { HelpCenterLink })}
        </Message>
      </Body>
      <Footer>
        <Button
          wide
          decoration="primary"
          onClick={handleClose}
        >
          {I18n.t('publisher.action.ok')}
        </Button>
      </Footer>
    </Popup>
  )
}
